export default __webpack_public_path__ + "static/media/img4.3bd7ff73.webp";